module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_9006.003afc7c.png";